<h2>Medborgarskap</h2>
<p>I vilket land är du medborgare?</p>

@for (country of countries(); track $index) {
    <spb-country-select
      [(model)]="country"
      [excluded]="countryList()"
      [required]="true"
      label="Medborgarskap"
    />
    @if ($index === 1) {
      <button matButton="text" (click)="removeNationality()"
              [style.padding]="0">
        - Ta bort
      </button>
    }
}
@if (countries().length === 1) {
  <p>Om du är medborgare i mer än ett land, klicka på "Lägg till" nedan.</p>
  <button (click)="addNationality()" class="add-more-button">
    <div class="centered-button">
      <mat-icon>add</mat-icon>
      <span>Lägg till</span>
    </div>
  </button>
}
